// @flow
import {
    postWav,
} from '../services/analyze';


export const EMOTION = 'EMOTION';
const emotion = res => ({
    type: EMOTION,
    payload: res,
});
export const getEmotion = (wavData) =>
    (dispatch: Function) => postWav(wavData)
        .then((res) => {
            dispatch(emotion(res));
            return res;
        });